import { forwardRef } from "react";
import CardTitle from "../card/cardTitle";
import { twMerge } from "tailwind-merge";

export interface ModalTitleProps extends React.HTMLAttributes<HTMLDivElement> {}

const ModalTitle = forwardRef<HTMLDivElement, ModalTitleProps>((props, ref) => {
  const { className, ...rest } = props;
  return (
    <CardTitle
      {...rest}
      ref={ref}
      className={twMerge("flex-1", className)}
    />
  );
});

export default ModalTitle;
